import {lazy} from 'react';

export const RteImgLazy = lazy(() => import(/* webpackChunkName: "rteImg" */ '.'));
